import styled from "styled-components"
import Select from "react-select"
import { genreOptions, paysOptions, yearsOptions } from "../../Utils/datas"
import { customTheme, episodesCustomStyles } from "../../Utils/selectStyle"
import { colors } from "../../Utils/color"
import { useEffect, useState } from "react"
import { MovieElementDiv, slugify } from "../../Components/MoviesSlider"
import PaginationMovies from "../../Components/PaginationMovies"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { LoaderDiv } from "../../Utils/style"
import { AddBannerDiv } from "../Home"
import AdsterraBanner from "../../Components/AdsterraBanner"

const MoviesListDiv = styled.div`
    height: 100%;
    padding: 100px 120px;
    @media screen and (max-width: 744px) {
        padding: 90px 10px;
    }
    @media screen and (min-width: 744px) and (max-width: 1024px) {
        padding: 100px 20px;
    }
`
const TrieDiv = styled.div`
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    background-color: black;
    padding: 20px;
    border-radius: 10px;

    > h2 {
        width: 100%;
        margin: 0;
    }

    > p {
        font-size: 1.1em;
        padding: 10px 15px;
        align-self: center;
        background-color: ${colors.secondary};
        border-radius: 8px;
        margin: 0;
    }
`
export const MoviesDiv = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
    margin: 20px 0 60px 0;
    @media screen and (max-width: 1024px) {
        gap: 10px;
    }
`

function MoviesList() {
    const { fstv } = useParams()
    //const { type } = useParams()
    const [type, seType] = useState("")

    const [searchParams, setSearchParams] = useSearchParams()

    const genre = searchParams.get("genre") || "Tout"
    const pays = searchParams.get("pays") || "Tout"
    const annee = searchParams.get("annee") || "Tout"

    const [selectedGenre, setSelectedGenre] = useState(null)
    const [selectedPays, setSelectedPays] = useState(null)
    const [selectedYear, setSlectedYear] = useState(null)

    const [movies, setMovies] = useState([])
    const currentPage = parseInt(searchParams.get("page") || "1", 10)

    const [totalPages, setTotalPages] = useState(0)
    const moviesPerPage = 36

    const [loading, setLoading] = useState(true)

    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1)
    }

    const handleGenreChange = async (option) => {
        setSelectedGenre(option)
        const params = {
            page: "1",
        }

        if (option.value.toString() !== "Tout") {
            params.genre = option.value.toString()
        }

        if (pays !== "Tout") {
            params.pays = pays.toString()
        }

        if (annee !== "Tout") {
            params.annee = annee.toString()
        }

        setSearchParams(params, { replace: false })
    }

    const handleNationaliteChange = async (option) => {
        setSelectedPays(option)
        const params = {
            page: "1",
        }

        if (genre !== "Tout") {
            params.genre = genre.toString()
        }

        if (option.value.toString() !== "Tout") {
            params.pays = option.value.toString()
        }

        if (annee !== "Tout") {
            params.annee = annee.toString()
        }

        setSearchParams(params, { replace: false })
    }

    const handleAnneeChange = async (option) => {
        setSlectedYear(option)
        const params = {
            page: "1",
        }

        if (genre !== "Tout") {
            params.genre = genre.toString()
        }

        if (pays !== "Tout") {
            params.pays = pays.toString()
        }
        if (option.value.toString() !== "Tout") {
            params.annee = option.value.toString()
        }

        setSearchParams(params, { replace: false })
    }

    const fetchMovies = async (table, page, limit, genre, pays, annees) => {
        try {
            const API_BASE =
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:8787"
                    : window.location.origin

            const response = await fetch(
                `${API_BASE}/api/fstv?table=${table}&page=${page}&limit=${limit}&genre=${genre}&pays=${pays}&annees=${annees}`,
            )
            const result = await response.json()

            setMovies(result.items)
            setTotalPages(result.totalPages)
        } catch (error) {
            console.log("Fetch error: ", error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        document.title = `Streamflix-fr | ${
            fstv ?? "Streamflix-fr"
        } en streaming`
        if (searchParams.has("genre")) {
            setSelectedGenre({
                value: searchParams.get("genre"),
                label: searchParams.get("genre"),
            })
        } else if (searchParams.has("pays")) {
            setSelectedPays({
                value: searchParams.get("pays"),
                label: searchParams.get("pays"),
            })
        } else if (searchParams.has("annee")) {
            setSlectedYear({
                value: searchParams.get("annee"),
                label: searchParams.get("annee"),
            })
        }
        seType(fstv)
        if (type !== "")
            fetchMovies(type, currentPage, moviesPerPage, genre, pays, annee)
    }, [
        fstv,
        type,
        currentPage,
        moviesPerPage,
        genre,
        pays,
        annee,
        searchParams,
    ])

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            const params = {
                page: page.toString(),
            }

            if (genre !== "Tout") {
                params.genre = genre.toString()
            }

            if (pays !== "Tout") {
                params.pays = pays.toString()
            }
            if (annee !== "Tout") {
                params.annees = annee.toString()
            }

            setSearchParams(params, { replace: false })

            window.scrollTo(0, 0)
        }
    }

    const navigate = useNavigate()
    const movieHandleClick = (id, titre) => {
        const urlTitle = slugify(titre)

        if (type === "films") {
            navigate(`/film/${urlTitle}?film_id=${id}`)
        } else if (type === "series") {
            navigate(`/serie/${urlTitle}?serie_id=${id}`)
        }
    }

    const isMobile = window.innerWidth < 768

    return (
        <MoviesListDiv>
            <TrieDiv>
                <h2>Filtres</h2>
                <p>{capitalizeFirstLetter(type)}</p>

                <Select
                    id="selectGenre"
                    options={genreOptions}
                    value={selectedGenre}
                    styles={episodesCustomStyles}
                    theme={customTheme}
                    isSearchable={false}
                    onChange={handleGenreChange}
                    menuPortalTarget={null}
                    placeholder="Par genres"
                />

                <Select
                    id="selectpays"
                    options={paysOptions}
                    value={selectedPays}
                    styles={episodesCustomStyles}
                    theme={customTheme}
                    isSearchable={false}
                    onChange={handleNationaliteChange}
                    menuPortalTarget={null}
                    placeholder="Par pays"
                />

                <Select
                    id="selectAnnee"
                    options={yearsOptions}
                    value={selectedYear}
                    styles={episodesCustomStyles}
                    theme={customTheme}
                    isSearchable={false}
                    onChange={handleAnneeChange}
                    menuPortalTarget={null}
                    placeholder="Par années"
                />
            </TrieDiv>

            <AddBannerDiv style={{ marginTop: "10px" }}>
                <p>
                    Cliquer sur les pub est le meilleur moyen de nous soutenir
                </p>
                {isMobile ? (
                    <AdsterraBanner
                        keyId="36095d1eafe994c25e794db19ac32ddd"
                        width={320}
                        height={50}
                    />
                ) : (
                    <AdsterraBanner
                        keyId="dcfa5d9b41f84b62a0d227806e4b1618"
                        width={728}
                        height={90}
                    />
                )}
            </AddBannerDiv>

            {loading && <LoaderDiv />}

            {!loading && movies && (
                <MoviesDiv>
                    {movies.map(({ id, titre, cover }) => (
                        <MovieElementDiv
                            key={id}
                            onClick={() => movieHandleClick(id, titre)}
                        >
                            <img src={cover} alt="Movies cover" />
                            <p>{titre}</p>
                        </MovieElementDiv>
                    ))}
                </MoviesDiv>
            )}

            {!loading && !movies && (
                <h2>
                    Oups ! Il semble qu’on n’arrive pas à trouver de résultats
                    pour votre selection
                </h2>
            )}

            {movies.length > 0 ? (
                <PaginationMovies
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            ) : (
                <p></p>
            )}
        </MoviesListDiv>
    )
}

export default MoviesList
/*
style={{
                    display: !loading && movies.length > 0 ? "none" : "initial",
                }}
*/
